import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function NextSteps() {
  return <section data-section-id="234572" id="immediate-exit-assessment" className="bg-background text-foreground border-t border-primary/20 py-16 px-4 md:px-8 flex flex-col items-center justify-center text-center relative overflow-hidden">
      {}
      <div className="max-w-3xl mx-auto flex flex-col items-center relative z-10">
        <span className="text-muted-foreground font-default text-sm uppercase tracking-widest mb-4">
          Phase 1: Readiness
        </span>
        <h2 className="text-foreground font-serif text-3xl md:text-4xl font-bold mb-8 leading-tight">
          Get Your Leaving Illinois Exit Plan Today
        </h2>
        <p className="text-muted-foreground font-default text-lg mb-8 max-w-2xl">
          This first step helps clarify whether leaving Illinois makes sense for you — and when.
        </p>
        <Button asChild className="bg-[#002868] hover:bg-[#001a45] text-white border-b-4 border-[#bf0a30] rounded-lg shadow-xl text-2xl font-bold h-auto py-6 px-16 transition-all transform hover:scale-105">
          <Link to="#">
            Start Your Exit Plan
          </Link>
        </Button>
      </div>
      
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/noise_texture.png')] opacity-[0.03] pointer-events-none"></div>
    </section>;
}